export default __webpack_public_path__ + "static/media/logo_megabus.0e543e1c.svg";